<template>
  <article
    ref="root"
    class="Conversation"
    :class="{ '-expanded' : isExpanded, '-page': isPage, 'panel' : isExpanded }"
    :aria-label="conversation[0]?.summary || conversation[0]?.retweeted_status?.summary || $t('timeline.unsubjected_conversation')"
  >
    <div
      v-if="isExpanded"
      ref="panelHeader"
      class="panel-heading conversation-heading -sticky"
    >
      <component :is="isPage ? 'h1' : 'h2'" class="title">
        <RichContent
          v-if="conversation[0]?.summary_raw_html"
          :html="conversation[0].summary_raw_html"
          :emoji="conversation[0].emojis"
        />
        <template v-else>
          {{ $t('timeline.conversation') }}
        </template>
      </component>
      <button
        v-if="!isPage"
        class="button-unstyled"
        @click.prevent="toggleExpanded"
      >
        {{ $t('timeline.collapse') }}
      </button>
      <QuickFilterSettings
        v-if="isPage && mobileLayout"
        :conversation="true"
        class="rightside-button"
      />
      <QuickViewSettings
        v-if="isPage"
        :conversation="true"
        class="rightside-button"
      />
    </div>
    <div
      v-if="isPage && !currentStatus"
      class="conversation-body"
      ref="body"
      :class="{ 'panel-body': isExpanded }"
    >
      <p v-if="!loadError">
        <FAIcon
          spin
          icon="circle-notch"
        />
        {{ $t('status.loading') }}
      </p>
      <p v-else>
        {{ $t('status.load_error', { error: loadError }) }}
      </p>
    </div>
    <div
      v-else
      class="conversation-body"
      ref="body"
      :class="{ 'panel-body': isExpanded }"
    >
      <div
        v-if="isTreeView"
        class="thread-body"
      >
        <div
          v-if="shouldShowAllConversationButton"
          class="conversation-dive-to-top-level-box"
        >
          <i18n-t
            keypath="status.show_all_conversation_with_icon"
            tag="button"
            class="button-unstyled"
            scope="global"
            @click.prevent="focusTopLevel"
          >
            <template #icon>
              <FAIcon
                icon="angle-double-left"
              />
            </template>
            <template #text>
              <span>
                {{ $t('status.show_all_conversation', { numStatus: topLevel.length - 1 }, topLevel.length - 1) }}
              </span>
            </template>
          </i18n-t>
        </div>
        <div
          v-if="shouldShowAncestors"
          ref="ancestors"
          class="thread-ancestors"
        >
          <template
            v-for="element in heightChartAncestors"
            :key="element.id"
          >
            <Status
              v-if="element.type === 'item'"
              class="conversation-status panel-body"
              :class="getStatusClasses(element.id, true)"

              :status-id="element.id"
              :replies="getReplies(element.id)"

              :focused="focusedId === element.id"
              conversation-rank="ancestor"
              :data-status-id="element.id"
              :data-vs-height="element.height"
              :data-vs-top="element.top"
              :data-vs-suspend="element.suspendable"

              @request-focus="setFocused"
              @toggle-thread-display="toggleThreadDisplay"
              @suspendable-state-change="changeSuspendStateAncestorsLocal"
              @height-change="updateVirtualHeightAncestors"
            />
            <div
              v-if="element.type === 'spacer'"
              class="virtual-spacer"
              role="presentation"
              :style="{ height: element.height + 'px' }"
              aria-hidden="true"
            />
          </template>
        </div>
        <ThreadTree
          ref="tree"
          :status-id="focusedId ?? currentStatus.id"
          :depth="0"

          @request-focus="setFocused"
          @toggle-expanded="toggleExpanded"
          @toggle-thread-display="toggleThreadDisplay"
          @show-thread-recursively="showThreadRecursively"
          @suspendable-state-change="changeSuspendStateCurrentLevelLocal"
        />
      </div>
      <div
        v-else-if="isLinearView"
        ref="linear"
        class="thread-body linear-view"
      >
        <template
          v-for="element in heightChartLinear"
          :key="element.id"
        >
          <Status
            v-if="element.type === 'item'"
            class="panel-body conversation-status"
            :class="getStatusClasses(element.id)"
            :status-id="element.id"
            :replies="getReplies(element.id)"

            :focused="focusedId === element.id"

            :data-status-id="element.id"
            :data-vs-height="element.height"
            :data-vs-top="element.top"

            @request-focus="setFocused"
            @toggle-expanded="toggleExpanded"
            @toggle-thread-display="toggleThreadDisplay"
            @suspendable-state-change="changeSuspendStateLinearLocal"
            @height-change="updateVirtualHeightLinear"
          />
          <div
            v-if="element.type === 'spacer'"
            :data-vs-id="element.id"
            aria-hidden="true"
            class="panel-body virtual-spacer"
            :style="{ height: element.height + 'px' }"
          />
        </template>
      </div>
    </div>
  </article>
</template>

<script src="./conversation.js"></script>
<style src="./conversation.scss" />
